import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ICalendarEvent } from 'app/interfaces/event.interface';
import { DateTimeService } from 'app/services/datetime.service';

@Component({
	selector: 'appointment-details-alert',
	templateUrl: './appointment-details-alert.component.html',
	styleUrls: ['./appointment-details-alert.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class AppointmentDetailsAlertComponent {
	@Input()
	public event: ICalendarEvent;

	constructor(public dateTimeService: DateTimeService) {}

	public shouldShowNoPromptuaryAlert(): boolean {
		if (this.event.hasPromptuary) {
			return false;
		}

		if (this.event.status !== 'paid') {
			return false;
		}

		if (!this.dateTimeService.dateTimeIsBefore(this.event.dayEnd)) {
			return false;
		}

		return true;
	}
}
